import { API_METHOD_GET } from "../config/constants";
import { store } from "../store";

export function queryBuilder(url, query) {
  var newUrl = url;
  if (
    query &&
    Object.keys(query).length > 0 &&
    Object.values(query).find((v) => v && v != "")
  ) {
    newUrl += "?";
    Object.keys(query).map((q, index) => {
      if (query[q]) {
        if (index > 0 && newUrl.charAt(newUrl.length - 1) != "?") {
          newUrl += "&" + q + "=" + query[q];
        } else {
          newUrl += q + "=" + query[q];
        }
      }
    });
  }
  return newUrl;
}

export const getApiHeader = (method, authorized, isFile) => {
  let headers = {
    Accept: "application/json",
  };
  if (method !== API_METHOD_GET) {
    if (!isFile) {
      headers["Content-Type"] = "application/json";
    }
  }
  if (authorized) {
    const state = store.getState();
    const accessToken = state?.auth?.accessToken;

    headers["Authorization"] = "Bearer " + accessToken;
  }

  return headers;
};

export const getApiBody = (method, body, isFile) => {
  if (method !== API_METHOD_GET) {
    if (isFile) {
      const formData = new FormData();
      const keys = Object.keys(body);
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i];
        formData.append(key, body[key]);
      }
      return formData;
    } else {
      return JSON.stringify(body);
    }
  } else {
    return null;
  }
};
